import { toast } from '@repo/toast';
import { getLabels } from '../labels';
/**
 * Single entry point for "copy this text and tell the user it worked".
 *
 * Writes to the clipboard and raises a success toast, or a shared error toast
 * when the write is rejected — clipboard access fails on denied permission and
 * in non-secure contexts, and an uncaught rejection would leave the user with
 * no feedback at all.
 *
 * `testIdSuffix` names the success toast; the error toast is always suffixed
 * `errorToast`.
 */
export function useClipboardCopy(testId) {
    const { copyError } = getLabels().input;
    const copyToClipboard = async (text, { successMessage, testIdSuffix }) => {
        try {
            await navigator.clipboard.writeText(text);
            toast.success(successMessage, testId.append(testIdSuffix));
        }
        catch {
            toast.danger(copyError, testId.append('errorToast'));
        }
    };
    return { copyToClipboard };
}
